import { Input, OnDestroy } from '@angular/core';
import { Component, OnInit, TemplateRef } from '@angular/core';
import * as Highcharts from 'highcharts';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { AnalyticsService } from '../../../shared/providers/analytics.service';
import { CommonService } from '../../../shared/providers/common.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { ValidationService } from '../../../shared/providers/validation.service';

declare var require: any;
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
interface IWatchListData {
  name: string;
  Id: number;
  data: [];
}
interface IDropDownData {
  value: number;
  display: string;
  TypeId: number;
}
interface IMyTenants {
  Id: number;
  MyPropertyList?: [];
  PropertyType?: string;
  TypeCurrentRate?: number;
  TypeIncrease?: number;
  TypeStatusId?: number;
  TotalRate?: number;
  TotalIncreased?: number;
  TotalStatusId?: number;
  AvailableProperties?: number;
  Name?: string;
  InfoText?: string;
  InfoTextTenant?: string;
}
@Component({
  selector: 'app-watch-list',
  templateUrl: './watch-list.component.html',
  styleUrls: ['./watch-list.component.css']
})
export class PortfolioWatchListComponent implements OnInit, OnDestroy {
  currentMenu = '';
  constructor(private _commonService: CommonService, private propertyService: PropertyListingService, private Analytics: AnalyticsService, private _toastService: ToastService, public Validation: ValidationService, private modalService: BsModalService, public authentication: AuthenticationService, private _userManagerService: UserManagerService, private Loader: LoaderService) {
  }
  private _watchListSubscriptions: Subscription[] = [];
  modalRef: BsModalRef;
  tenantlst: IDropDownData[];
  tenants: any[];
  chartData: IWatchListData = {} as any;
  user: any;
  barChartData = [] as any;
  showAddwatchList: number = 0;
  barChartData1 = [] as any;
  watchlistData = [] as any;
  currentUser: any;
  months = [];
  savedTenants: IMyTenants[];
  selectedTenants: number[] = [];
  watchlistcount = [];
  tenantIds = [];
  maxCount: number = 3;
  currentTenantCount = 3;
  @Input() UserGuid: string = '0000';
  @Input() IsmyPortfolio: boolean = true;
  @Input() PortfolioName: string = 'My Watchlist';

  ngOnInit() {
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000'
    this.user = this.authentication.user;
    this.getMonths()
    this.getChartData();
  }

  ngOnDestroy() {
    this._watchListSubscriptions.forEach(sub => sub.unsubscribe());
  }

  getTenantList() {
    this.tenants = [];
    this._commonService.getTenantsForUsers(this.user.Id, this.UserGuid).subscribe(res => {
      this.tenants = res.map(o => {
        return {
          value: o.Id, display: o.TenantName, TypeId: 0
        };
      });
      if (res != null && res.length > 0) {
        this.selectedTenants = res.map(o => o.Id);
      }
      else {
        this.selectedTenants = [];
      }

    });
  }

  getChartData() {
    this._watchListSubscriptions.push(this.Analytics.GetWatchList(this.user.Id, this.UserGuid).subscribe(response => {
      let data = response;
      this.barChartData1 = data;
      if (data != null && data.length > 0) {
        let tenantData1 = data.filter(d => d.Id).map(i => i.Id);

        tenantData1 = tenantData1.map(ar => JSON.stringify(ar))
          .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
          .map(str => JSON.parse(str));
        this.savedTenants = tenantData1.map(o => ({ Id: o, MyPropertyList: [] }))

        let tenantList = this.savedTenants != null && this.savedTenants.length > 0 ? this.savedTenants.length : 0;
        this.currentTenantCount = tenantList;

        setTimeout(() => { this.bindChart1(); }, 500);
      }
      else {
        this.savedTenants = [];
        this.currentTenantCount = 0;
      }
    }));
  }


  bindChart1() {
    let alldata = this.barChartData1;
    let i = 0;
    let minimumValue = 0;
    this.savedTenants.forEach(s => {
      let categoryData = [];
      let informationText = '';
      this._watchListSubscriptions.push(this.propertyService.getPrincipalHighlight(s.Id, this.user.Id, this.UserGuid).subscribe(response => {
        if (response != null) {
          categoryData = response;
          if (response[10].PropertyType != null) {
            s.PropertyType = response[10].PropertyType;
            s.TypeCurrentRate = response[11].AvgCapRate;
            let previous = response[10].AvgCapRate;
            let current = response[11].AvgCapRate;
            let rating = current.toFixed(2);
            if (current >= previous) {
              let difference = current - previous;
              if (difference > 0) {
                let differenceText = difference.toFixed(2);
                difference = parseFloat(difference.toFixed(2));
                s.TypeStatusId = 1;
                informationText = 'The average asking cap rate has increased by ' + differenceText + ' % from the previous month.';
                s.InfoText = informationText;
              }
              else {
                s.TypeStatusId = 0;
                informationText = 'The average asking cap rate has not changed from the previous month.';
                s.InfoText = informationText;
              }
              s.TypeIncrease = difference;
            }
            else {
              s.TypeStatusId = 2;
              let difference = previous - current;
              let differenceText = difference.toFixed(2);
              if (difference > 0) {
                difference = parseFloat(difference.toFixed(2));
                informationText = 'The average asking cap rate has decreased by ' + differenceText + ' % from the previous month.';
                s.InfoText = informationText;
              }
              s.TypeIncrease = difference;
            }
          }
        }

        let num = 0;
        let pointIncrease = 0;
        let tenantName = this.barChartData1.filter(x => x.Id == s.Id).map(i => i.Name)[0];
        let monthdata = [] as any;
        let categorychartdata = [] as any;
        let currentRating = 0;
        let categorychartname = response[0].PropertyType;
        let previousMonthRating = 0;
        let availableProp = 0;
        this.months.forEach(t => {
          let data1 = this.barChartData1.filter(x => x.Id == s.Id);
          this.watchlistcount = num <= 12 ? data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0] : data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[1];
          if (num == 11) {
            currentRating = data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0];
            availableProp = data1.filter(x => x.XAxis == t).map(i => i.ActiveListing)[0];
          }
          if (num == 10) {
            previousMonthRating = data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0];
          }
          monthdata.push(this.watchlistcount);
          categorychartdata.push(response.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0]);

          num = num + 1;
        });

        this.watchlistData = [] as any;
        this.watchlistData = [{
          name: tenantName,
          data: monthdata.map(i => i),
          color: '#02C29F',
          marker: {
            "symbol": "circle"
          }
        }];
        if (monthdata != null && monthdata != undefined && monthdata.length > 0) {
          minimumValue = monthdata.reduce((a, b) => Math.min(a, b));
        }
        if (categorychartname != null && categorychartname != undefined) {
          let watchlistData1 = {} as any;
          watchlistData1 = {
            name: categorychartname,
            data: categorychartdata.map(i => i),
            color: '#FFC32B',
            marker: {
              "symbol": "circle"
            }
          };
          this.watchlistData.push(watchlistData1);
          let newmin = categorychartdata.reduce((a, b) => Math.min(a, b));
          minimumValue = (monthdata != null && monthdata.length > 0) ? minimumValue > newmin ? newmin : minimumValue : newmin;
          minimumValue = minimumValue > 1 ? (minimumValue - 1) : minimumValue;
        }
        else {
          minimumValue = minimumValue > 1 ? (minimumValue - 1) : minimumValue;
        }

        const chart = {
          chart: {
            type: 'spline',
            height: 250,
          },

          title: {
            text: ''
          },
          xAxis: {
            categories: this.months.map(i => i),
            crosshair: true,
            title: {
              text: ''
            },

          },
          yAxis: {
            gridLineWidth: 0,
            minorGridLineWidth: 0,
            tickInterval: 0.5,
            min: minimumValue,
            title: {
              text: ''
            },
            labels: {
              format: '{value}%'
            },

          },
          legend: {
            enabled: true,
            itemStyle: {
              fontWeight: 'normal'
            }
          },
          credits: {
            enabled: false
          },

          tooltip: {
            headerFormat: '',
            pointFormatter: function () {
              var point = this;
              var currentSeries = point.series;
              if (currentSeries.name == tenantName) {
                let activelistingCount = alldata.filter(i => i.Id == s.Id && i.XAxis == point.category).map(i => i.ActiveListing)[0];
                let year = alldata.filter(i => i.Id == s.Id && i.XAxis == point.category).map(i => i.Year)[0];
                return '<table><tr><td padding:0"> ' + tenantName + ' : </td><td style="padding:0">' + point.category + ' ' + year + '</td></tr><tr><td padding:0"> # Properties : </td><td style="padding:0"><b>' + activelistingCount + '</b></td></tr><tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + '%</b></td></tr>';
              }
              else {
                let activelistingCount = categoryData.filter(i => i.XAxis == point.category).map(i => i.ActiveListing)[0];
                let year = categoryData.filter(i => i.XAxis == point.category).map(i => i.Year)[0];
                return '<table><tr><td padding:0"> ' + categorychartname + ' : </td><td style="padding:0">' + point.category + ' ' + year + '</td></tr><tr><td padding:0"> # Properties : </td><td style="padding:0"><b>' + activelistingCount + '</b></td></tr><tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + '%</b></td></tr>';
              }
            },
            footerFormat: '</table>',
            // distance: 30,
            shared: false,
            useHTML: true,
            shadow: false,

          },
          plotOptions: {
            line: {
              lineWidth: 2,
              states: {
                hover: {
                  lineWidthPlus: 1,
                },
              },
            },
          },
          series: this.watchlistData
        }
        let newId = 'Container' + s.Id;
        let mainDiv = 'highchartGraph' + s.Id;
        let infomationText = '';
        let typeRating = currentRating.toFixed(2);
        if (currentRating >= previousMonthRating) {
          pointIncrease = currentRating - previousMonthRating;
          if (pointIncrease > 0) {
            let pointIncreaseText = pointIncrease.toFixed(2);
            pointIncrease = parseFloat(pointIncrease.toFixed(2));
            s.TotalStatusId = 1;
            informationText = 'The average asking cap rate has increased by ' + pointIncreaseText + ' % from the previous month.';
            s.InfoTextTenant = informationText;
          }
          else {
            s.TotalStatusId = 0;
            informationText = 'The average asking cap rate has not changed from the previous month.';
            s.InfoTextTenant = informationText;
          }
        }
        else {
          pointIncrease = previousMonthRating - currentRating;
          pointIncrease = parseFloat(pointIncrease.toFixed(2));
          s.TotalStatusId = 2;
          if (pointIncrease > 0) {
            let pointIncreaseText = pointIncrease.toFixed(2);
            pointIncrease = parseFloat(pointIncrease.toFixed(2));
            informationText = 'The average asking cap rate has decreased by' + pointIncreaseText + '% from the previous month.';
            s.InfoTextTenant = informationText;
          }
        }
        i = i + 1;
        if (document.getElementById(mainDiv)) {
          document.getElementById(mainDiv).style.display = 'block';
        }
        s.TotalRate = currentRating;
        s.TotalIncreased = pointIncrease;
        s.AvailableProperties = availableProp;
        s.Name = tenantName;
        if (document.getElementById(newId)) {
          Highcharts.chart(newId, chart);
        }
      }));
    });
  }
  getMonths() {
    let currentYear = new Date().getFullYear();
    var today = this.Validation.convertUTCDateToLocalDate1(new Date());
    let range = [];
    var newDate = today;
    let selectedValue = 11;
    let monthDigit = newDate.getMonth() - selectedValue;
    newDate = new Date(newDate.getFullYear(), monthDigit, 1);
    for (var i = newDate; i <= new Date(); i.setMonth(newDate.getMonth() + 1)) {
      var month = i.toLocaleString('en-us', { month: 'short' });;
      range.push(month);
    }
    this.months = range;
  }

  onAdd(event, filtername) {
    if (event != null && event.value != null) {
      this.selectedTenants.push(event.value);
    }
  }
  tenantSearch(event) {
    this._commonService.GetInterestedTeanantBySearch(event).subscribe(response => {
      this.tenantlst = response.map(o => {
        return {
          value: o.Id, display: o.TenantName, TypeId: 0
        };
      });
    });
  }
  onRemove(event, filterName) {
    const index = this.selectedTenants.indexOf(event.value);
    if (index > -1) {
      this.selectedTenants.splice(index, 1);
    }
  }

  gettenantdetails() {
    this._commonService.GetWatchListTenantList().subscribe(response => {
      this.tenantlst = response.map(o => {
        return {
          value: o.Id, display: o.TenantName, TypeId: 0
        };
      });
    });
  }
  openAddWatchListModal(template: TemplateRef<any>, classes: any) {
    this.getTenantList();
    this.gettenantdetails();
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  AddTenant() {
    if (this.selectedTenants != null && this.selectedTenants.length > 0) {
      let totalTenantCount = this.selectedTenants.length;
      if (totalTenantCount > 3) {
        this._toastService.addToast({
          title: 'Warning',
          msg: 'Your limit has been exceeded',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
      }
      else {
        this.Loader.display(true);
        const saveWatchList = {
          UserId: this.user.Id,
          TenantId: this.selectedTenants,
          UserGuid: this.UserGuid
        }
        this._userManagerService.SaveWatchList(saveWatchList).subscribe(response => {
          if (response) {
            this.Loader.display(false);
            this.modalRef.hide();
            this.getChartData();
            this._toastService.addToast({ title: 'Success', msg: 'Watchlist added successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          }
          else {
            this.Loader.display(false);
            this.modalRef.hide();
            this._toastService.addToast({
              title: '',
              msg: 'Error Occurred',
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'error'
            });
          }
        });
      }
    }
    else {
      this._toastService.addToast({
        title: 'Warning',
        msg: 'Please select at least one tenant',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
  }

  expandChart(div) {
    if ($('#' + div).hasClass('expand-div')) {
      window.scrollTo(0, 0);
      $('#' + div).removeClass('expand-div');
      $('body').removeClass('modal-open');

    }
    else {
      window.scrollTo(0, 0);
      $('#' + div).addClass('expand-div');
      $('body').addClass('modal-open');
    }
    this.getChartData();
  }

  RemoveTenant(tenantId: number) {
    if (tenantId != null) {
      this._userManagerService.RemoveWatchList(tenantId, this.user.Id, this.UserGuid).subscribe(response => {
        if (response != null) {
          this.getChartData();
          const index = this.selectedTenants.indexOf(tenantId);
          if (index > -1) {
            this.selectedTenants.splice(index, 1);
          }
          this._toastService.addToast({ title: 'Success', msg: 'Tenant removed from watchlist successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        else {
          this._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Tenant could not be deleted from watchlist',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error'
          });
        }
      });
    }
  }

  getHightlightData(tenantId: number, index: number, mydata: any) {
    this.propertyService.getPrincipalHighlight(tenantId, this.user.Id, this.UserGuid).subscribe(response => {
      if (response != null) {
        if (response[10].PropertyType != null) {
          mydata.PropertyType = response[10].PropertyType;
          mydata.TypeCurrentRate = response[11].AvgCapRate;
          let previous = response[10].AvgCapRate;
          let current = response[11].AvgCapRate;
          if (current >= previous) {
            let difference = current - previous;
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2));
              mydata.TypeStatusId = 1;
            }
            else {
              mydata.TypeStatusId = 0;

            }
            mydata.TypeIncrease = difference;
          }
          else {
            mydata.TypeStatusId = 2;
            let difference = previous - current;
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2))
            }
            mydata.TypeIncrease = difference;
          }
        }
      }
    });
  }
}
